import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "../locales/en.json";
import myTranslation from "../locales/my.json";

export const DEFAULT_LANGUAGE = "my";
const runtimeDefaultLanguage = import.meta.env.MODE === "test" ? "en" : DEFAULT_LANGUAGE;

function getInitialLanguage(): "en" | "my" {
  try {
    const savedLanguage = localStorage.getItem("ym_language");
    if (savedLanguage === "en" || savedLanguage === "my") return savedLanguage;

    localStorage.setItem("ym_language", runtimeDefaultLanguage);
  } catch {
    // Storage can be unavailable in private or restricted browser contexts.
  }

  return runtimeDefaultLanguage;
}

const savedLanguage = getInitialLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      my: {
        translation: myTranslation,
      },
    },
    lng: savedLanguage,
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
